// extracted by mini-css-extract-plugin
export default {"cta-table":"CtaTable_cta-table__T5AKs"};